import axios from "axios";

export const fetchIntegrationDetails = async ({ integrationSlug, tabSlug }) => {
    return await axios
        .get(`github/integrations/${integrationSlug}/${tabSlug}`)
}
